module.exports = __webpack_public_path__ + "pc/img/career-designer.8f2b97e9.webp";